import { render, staticRenderFns } from "./account_recharge.vue?vue&type=template&id=38775733&scoped=true"
import script from "./account_recharge.vue?vue&type=script&lang=js"
export * from "./account_recharge.vue?vue&type=script&lang=js"
import style0 from "./account_recharge.vue?vue&type=style&index=0&id=38775733&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38775733",
  null
  
)

export default component.exports